<template>

      <form v-on:submit.prevent="sendMail">

        <div class="form-group">
          <label for="customer"><h4>Wie können wir Ihnen helfen?</h4></label>
          <select v-model="customer" id="customer" name="customer" required="required" class="form-control">
            <option disabled value="">Bitte wählen Sie Ihr Anliegen aus</option>
            <option value="customer">Ich habe eine Frage zu einer Bestellung</option>
            <option value="nocustomer">Ich habe eine andere Frage</option>
         </select>
        </div>

        <div v-if="isCustomer" class="form-group">
          <hr>
          <label for="customer"><span id="orderIdHelpBlock" class="form-text text-muted">Wählen Sie bitte den Marktplatz aus und geben Sie Ihre Bestellnummer ein.</span></label>
          <select v-model="marketplace" id="marketplace" name="customer" required="required" class="form-control">
            <option disabled value="">Bitte wählen Sie aus wo Sie gekauft haben</option>
            <option value="eshopping">eshopping.de</option>
            <option value="dilawshisha">dilawshisha.de</option>
            <option value="Amazon">Amazon</option>
            <option value="eBay">eBay</option>
            <option value="andere">andere</option>
          </select>
        </div>

        <div v-if="marketplace==='eBay'&&isCustomer" class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-arrow-circle-right"></i>
              </div>
            </div>
            <input v-model="ebayname" id="ebayname" name="orderId" placeholder="Ihr eBay-Name" type="text" aria-describedby="orderIdHelpBlock" required="required" class="form-control">
          </div>
        </div>

        <div v-if="isCustomer" class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-arrow-circle-right"></i>
              </div>
            </div>
            <input v-model="orderId" id="orderId" name="orderId" placeholder="Ihre Bestellnummer / OrderID" type="text" aria-describedby="orderIdHelpBlock" required="required" class="form-control">
          </div>
        </div>

        <hr style="margin-bottom: 30px">


        <div class="form-group mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-arrow-circle-right"></i>
              </div>
            </div>
            <input v-model="name" id="Name" name="Name" placeholder="Ihr Vor- und Nachname" type="text" required="required" class="form-control">
          </div>
        </div>

        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fa fa-arrow-circle-right"></i>
              </div>
            </div>
            <input v-model="email" id="email" name="email" placeholder="Ihre E-Mail Adresse" type="email" class="form-control">
          </div>
        </div>

        <div class="form-group">
          <label for="message">Ihre Nachricht an uns</label>
          <textarea v-model="message" id="message" name="message" cols="40" rows="5" required="required" class="form-control"></textarea>
        </div>
        <div class="form-group">
          <button :disabled="!sendbuttton" name="submit" type="submit" class="btn btn-primary float-right">Nachricht Absenden</button>
        </div>
      </form>

</template>

<script>
export default {
  name: "ContactForm",

  data() {
    return {
      customer: '',
      orderId: '',
      marketplace: '',
      name: '',
      email: '',
      message: '',
      sendbuttton: true,
      ebayname: ''
    }
  },

  methods: {
    sendMail () {

      this.sendbuttton = false

      let username = 'Name des Kunden: ' + this.name  + ' -- ';

      let marketplace = (this.marketplace) ? 'Gekauft bei: ' + this.marketplace : ''

      let ebayname = (this.ebayname) ? '-- eBay-Name: ' + this.ebayname: ''

      // We build the obj manuely to send it in the same way as the wizard
      const data = {
          "currendOrderId": this.orderId,
          "customerId":null,
          "customer_name":this.name,
          "customer_email":this.email,
          "reason":"contactform",
          "reasonString":"Anfrage über Kontaktformular",
          "solveWish":null,
          "text":{
            "problemDiscription": username + marketplace + ebayname,
            "additionalText": this.message},
            "images":{"image1":false,"image2":false,"image3":false,"image4":false,"image5":false,"image6":false}
      }


      this.$RestClient.sendMail2Service( data )
          .then(() => {
            this.$emit('mailsend')
          })}

  },

  computed: {
    isCustomer () {
      return this.customer === 'customer';
    }
  }
}
</script>

<style scoped>

</style>